import { emptyDatiqPanelPopupForm } from '@dat/datiq-components-pkg/panel-popup';
import { DATIQ_DEFAULT_ID } from '@dat/datiq-core/models';
import { IDatiqCellPopupForm } from './datiq-cell-popup-form.interface';

export const emptyDatiqCellPopupForm: IDatiqCellPopupForm = {
    id: DATIQ_DEFAULT_ID('datiq-cell-popup-form'),
    form: emptyDatiqPanelPopupForm,
};
